import axios from "axios";

//let url = "https://erp.ldlerp.com/backend/public/api";
// let url = "https://demo.limerickbd.com/backend/public/api";
// let url = "http://127.0.0.1:8000/api";
let url = "https://accounts-backend.limerickbd.com/public/api";
// let url = "http://accounts.projectsample.info/backend/public/api";

export default axios.create({
  url: url,
  baseURL: url,
  headers: {
    Accept: "application/json",
    Authorization: "Bearer " + localStorage.getItem("token"),
    "Access-Control-Allow-Credentials": true,
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
  },
});
